/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} True_Still_Mole_RollInputs */

const en_true_still_mole_roll = /** @type {(inputs: True_Still_Mole_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleted`)
};

const de_true_still_mole_roll = /** @type {(inputs: True_Still_Mole_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelöscht`)
};

/**
* | output |
* | --- |
* | "Deleted" |
*
* @param {True_Still_Mole_RollInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const true_still_mole_roll = /** @type {((inputs?: True_Still_Mole_RollInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<True_Still_Mole_RollInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_true_still_mole_roll(inputs)
	return de_true_still_mole_roll(inputs)
});